import React from 'react';

function TermsConditions() {
  return (
    <section className="terms-conditions section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="cont">
              <h3 className="mb-20">
                Terms & Conditions – <span className="fw-200">Bizdoc</span>
              </h3>
              <p>
                Welcome to Bizdoc. By accessing or using our website (www.bizdoc.ae) or engaging with our services—including business setup services in UAE, PRO services, visa assistance, family visa services, Golden Visa UAE solutions, document attestation, bank account opening, trademark registration, legal services, and compliance support—you agree to the following Terms & Conditions.
              </p>

              <h4 className="mt-30">1. Use of Our Website & Services</h4>
              <ul className="mb-30 about-us-li">
                <li>You agree to use our website and services only for lawful purposes.</li>
                <li>Unauthorized use, data scraping, or misuse of content is prohibited.</li>
                <li>Bizdoc reserves the right to restrict access to any user who violates these terms.</li>
              </ul>

              <h4 className="mt-20">2. Service Scope</h4>
              <p>
                Bizdoc provides end-to-end business setup services in UAE and corporate solutions, including but not limited to:
              </p>
              <ul className="mb-30 about-us-li">
                <li>Company formation in Dubai & across UAE (mainland, free zone, offshore).</li>
                <li>Visa & immigration services (Golden Visa UAE, family visas, employment visas).</li>
                <li>PRO services, government approvals, and compliance.</li>
                <li>Bank account opening and financial support.</li>
                <li>Trademark registration and legal solutions.</li>
              </ul>
              <p>
                All services are subject to UAE laws, and government approvals are at the discretion of respective authorities.
              </p>

              <h4 className="mt-20">3. Fees & Payments</h4>
              <ul className="mb-30 about-us-li">
                <li>Service fees will be communicated clearly before engagement.</li>
                <li>All payments must be made as agreed in the service contract.</li>
                <li>Government fees, fines, or third-party charges are separate from Bizdoc's service charges unless specified.</li>
                <li>Refunds are not applicable once government submissions or processes have begun.</li>
              </ul>

              <h4 className="mt-20">4. Client Responsibilities</h4>
              <p>
                By engaging Bizdoc, you agree to:
              </p>
              <ul className="mb-30 about-us-li">
                <li>Provide accurate and complete documents for processing.</li>
                <li>Comply with UAE laws and regulations during the course of services.</li>
                <li>Pay all service and government fees on time.</li>
              </ul>

              <h4 className="mt-20">5. Limitation of Liability</h4>
              <ul className="mb-30 about-us-li">
                <li>Bizdoc is not liable for delays or rejections caused by government authorities, banks, or external agencies.</li>
                <li>While we ensure accuracy and compliance, final approvals depend on UAE regulatory bodies.</li>
                <li>Bizdoc is not responsible for indirect losses, including loss of profits, caused by service delays or rejections.</li>
              </ul>

              <h4 className="mt-20">6. Intellectual Property</h4>
              <ul className="mb-30 about-us-li">
                <li>All website content, including text, graphics, and designs, is owned by Bizdoc.</li>
                <li>You may not copy, reproduce, or distribute our content without written permission.</li>
              </ul>

              <h4 className="mt-20">7. Confidentiality</h4>
              <p>
                We maintain strict confidentiality of client information and documents, except when disclosure is legally required.
              </p>

              <h4 className="mt-20">8. Governing Law & Jurisdiction</h4>
              <p>
                These Terms & Conditions are governed by the laws of the United Arab Emirates. Any disputes will be resolved under the jurisdiction of UAE courts.
              </p>

              <h4 className="mt-20">9. Modifications</h4>
              <p>
                Bizdoc reserves the right to update these Terms & Conditions at any time. Updates will be posted on our website, and continued use of our services indicates acceptance of the changes.
              </p>

              <h4 className="mt-20">10. Contact Us</h4>
              <p>
                For inquiries regarding these Terms & Conditions, reach out to us at:
              </p>
              <p className="mb-30">
                📧 <a href="mailto:info@bizdoc.ae" className="main-color">info@bizdoc.ae</a> | 📞 <a href="tel:+971524740055" className="main-color">+971 52 474 0055</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TermsConditions;